class User {
  constructor (data) {
    this.id = data ? data.id : ''
    this.username = data ? data.username : ''
    this.email = data ? data.email : ''
    this.created_at = data ? data.created_at : ''
    this.password = ''
  }
}

export default User



// WEBPACK FOOTER //
// ./src/models/User.js